function initSmallLayoutAnimations(){
    //Standard to top link animation
    $('#backtotop img').on('click',function () {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
    })
    initScrollDot()
    initDotWayPoints()
}

function initScrollDot() {
    var dot = $('#the-dot');
    dot.data('origin',parseInt(dot.css('top')));
    dot.fadeIn();
    $('#the-line').show();
}

function initDotWayPoints() {

    $('section.frame-container').each(function () {
        if($(this).hasClass('mask_ce_intro_homepage')){
            $(this).waypoint({
                handler: function (direction) {
                    if(direction === 'up'){
                        var dot = $('#the-dot');
                        dot.css('transform','translate(-50%,'+ 0  +'px)');
                    }
                },
                    offset: '15%'
            });
        }else{
            $(this).waypoint({
                handler: function (direction) {
                    if(direction === 'down'){
                        var dot = $('#the-dot');
                        var headerHeight = 0;
                        var addPx = 0;
                        var elOffesetTop = 0;
                        if($(this.element).find('.dot-stop').length > 0){
                            //check if we have header element
                            if($(this.element).find('header.dot-stop').length > 0){
                                headerHeight = $(this.element).find('header.dot-stop > *:first-child').height();
                                var dotHeight = dot.height();
                                if(headerHeight > dotHeight){
                                    addPx = (headerHeight - dotHeight) / 2
                                }
                                elOffesetTop = $(this.element).find('header.dot-stop').offset().top;
                            }else{
                                elOffesetTop = $(this.element).find('.dot-stop').first().offset().top;
                                addPx = 15;
                            }
                            var newDotPosition = elOffesetTop - parseInt(dot.css('top')) + addPx - $('#linewrap').offset().top;
                            dot.css('transform','translate(-50%,'+ newDotPosition  +'px)');
                        }
                    }
                },
                offset: '85%'
            });
            $(this).waypoint({
                handler: function (direction) {
                    if(direction === 'up'){
                        var dot = $('#the-dot');
                        var headerHeight = 0;
                        var addPx = 0;
                        var elOffesetTop = 0;
                        if($(this.element).find('.dot-stop').length > 0){
                            //check if we have header element
                            if($(this.element).find('header.dot-stop').length > 0){
                                headerHeight = $(this.element).find('header.dot-stop > *:first-child').height();
                                var dotHeight = dot.height();
                                if(headerHeight > dotHeight){
                                    addPx = (headerHeight - dotHeight) / 2
                                }
                                elOffesetTop = $(this.element).find('header.dot-stop').offset().top;
                            }else{
                                elOffesetTop = $(this.element).find('.dot-stop').first().offset().top;
                                addPx = 15;
                            }
                            var newDotPosition = elOffesetTop - parseInt(dot.css('top')) + addPx - $('#linewrap').offset().top;
                            dot.css('transform','translate(-50%,'+ newDotPosition  +'px)');
                        }
                    }
                },
                offset: '25%'
            });
        }
    });

}

// // Detect request animation frame
// var paraScroll = window.requestAnimationFrame ||
//     window.webkitRequestAnimationFrame ||
//     window.mozRequestAnimationFrame ||
//     window.msRequestAnimationFrame ||
//     window.oRequestAnimationFrame ||
//     // IE Fallback, you can even fallback to onscroll
//     function(callback){ window.setTimeout(callback, 1000/60) };
//
// var paraScrollLastPosition = -1;
//
// function paraLoop(){
//
//     // Where the magic goes
//     if (paraScrollLastPosition == window.pageYOffset) {
//         paraScroll(paraLoop);
//         return false;
//     } else{
//         paraScrollLastPosition = window.pageYOffset;
//         if($('.para-header').length > 0 ){
//             $('.para-header').css('transform','translate(0,-'+ (paraScrollLastPosition * 0.25) +'px)');
//         }
//
//     }
//
//     // Recall the loop
//     paraScroll( paraLoop )
// }
//
// // Call the loop for the first time
// paraLoop();